export default __webpack_public_path__ + "static/media/new.9a9adee9.svg";